export default __webpack_public_path__ + "static/media/fixture1_horizontal_line_red.99fb6478.png";